//@ts-nocheck
import { GetScriptsOutput } from '../../types'

export function getRebuttals(
  rebuttals: object,
  provider: 'ndr' | 'rga',
  payer: boolean,
  userRole: 'screener' | '*',
  lang: 'en' | 'es' = 'en',
  currentScriptIndex: number,
): GetScriptsOutput {
  const key = `${lang}_${userRole === '*' ? '' : `${userRole.toLowerCase()}_`}${payer ? 'payer' : 'nonpayer'}_${provider}`

  let filteredRebuttals = rebuttals[key]

  if (currentScriptIndex > -1 && rebuttals[key]) {
    const rebuttalKeys = Array.from(Object.keys(rebuttals[key]))

    const filteredRebuttalKeys = rebuttalKeys.filter((rebuttalKey) => {
      const filteredScriptIndices =
        rebuttals[key][rebuttalKey].filteredScriptIds || null
      return (
        filteredScriptIndices === null ||
        rebuttalKey === null ||
        !filteredScriptIndices.includes(currentScriptIndex.toString())
      )
    })

    if (rebuttalKeys.length != filteredRebuttalKeys) {
      filteredRebuttals = {}
      filteredRebuttalKeys.forEach((filteredRebuttalKey) => {
        filteredRebuttals[filteredRebuttalKey] =
          rebuttals[key][filteredRebuttalKey]
      })
    }
  }

  return filteredRebuttals || {}
}
